import { amplitude } from "@eis-poc/lib-discover-medical-mfes";

export const linkTypes = {
  INTERNAL_TOPIC: "internal-topic",
};

export const affordances = {
  RIGHT_RAIL: "right-rail",
  INLINE_TOPIC: "inline-topic",
  TOPIC_GALLERY: "topic-gallery",
  SEARCH_GALLERY: "search-gallery",
  PREVIOUS: "previous",
  NEXT: "next",
  PAGE: "page",
  HEADER: "header",
  PAGE_TOP: "page-top",
  PAGE_BOTTOM: "page-bottom",
  DRUG_MONOGRAPH: "drug_monograph",
  DRUG_MONOGRAPH_INLINE: "drug_monograph-inline",
  TOPIC_INLINE: "topic-inline",
  TOPIC_RIGHTRAIL: "topic-rightrail",
  TOPIC_BOTTOM: "topic-bottom",
  TABLE: "table",
  TABLE_FIND_IN_TOPIC: "find-in-topic",
  TABLE_CLINICAL_COLLECTIONS: "clinical-collection",
};

export const EVENTS = {
  topicViewed: "Topic - viewed",
  topicHiddenViewed: "Topic Hidden - viewed",
  topicSectionViewed: "Topic - section_viewed",
  tableViewed: "Table - viewed",
  topicShareClicked: "Topic - share_clicked",
  topicCiteClicked: "Topic - cite_clicked",
  topicCiteCopyClicked: "Topic - cite_copy_clicked",
  topicPrintClicked: "Topic - print_clicked",
  topicPrintConfirmClicked: "Topic - print_confirm_clicked",
  topicVideoGalleryViewed: "Topic Video Gallery - viewed",
  topicImageGalleryViewed: "Topic Image Gallery - viewed",
  topicAboutViewed: "Topic About - viewed",
  topicChecklistViewed: "Topic Checklist - viewed",
  topicAlgorithmsViewed: "Topic Algorithms - viewed",
  topicUpdatesViewed: "Topic Updates - viewed",
  topicInThisSectionClicked: "Topic - in_this_section_clicked",
  topicPageNavigationClicked: "Topic - page_navigation_clicked",
  topicHeaderLinkClicked: "Topic - header_link_clicked",
  tocClicked: "Table of Contents - clicked",
  imageViewed: "Image - viewed",
  algorithmViewed: "Algorithm - viewed",
  videoViewed: "Video - viewed",
  videoPlayed: "Video - played",
  findOnPageClicked: "Find on Page - clicked",
  findOnPageInitiated: "Find on Page - initiated",
  jumpLinkClicked: "Drug Jump Link - clicked",
  topicInDepthAnswersViewed: "Topic In Depth Answers - viewed",
  topicInDepthAnswersClicked: "Topic In Depth Answers - clicked",
  topicTablesGalleryViewed: "Topic Tables Gallery - viewed",
  topicFullTextLinkClicked: "Topic - full_text_link_clicked",
  topicContentLinkClicked: "Topic - content_link_clicked",
  tableViewInContextClicked: "Table - view_in_context_clicked",
  merativeLinkClicked: "Drug Merative Link - clicked",
  checkInteractionsClicked: "Check Interactions - clicked",
  boxedWarningClicked: "Boxed Warning - clicked",
  decisionsPlacardClicked: "Decisions Placard - clicked",
  relatedTopicsClicked: "Related Topics - clicked",
  relatedContentClicked: "Related Content - clicked",
  drugConsultsClicked: "Drug Consults - clicked",
  pdfViewed: "Pdf - viewed",
};

export const logTopicViewed = ({
  pubType,
  title,
  recordAn,
  isFreePreview,
  referringPage,
}) => {
  amplitude.log(EVENTS.topicViewed, {
    pub_type: pubType,
    title,
    record_an: recordAn,
    is_free_preview: isFreePreview,
    referring_page: referringPage,
  });
};

export const logTopicHiddenViewed = ({ pathname }) => {
  amplitude.log(EVENTS.topicHiddenViewed, { pathname });
};

export const logTopicImageGalleryViewed = ({
  pubType,
  title,
  recordAn,
  isFreePreview,
  referringPage,
}) => {
  amplitude.log(EVENTS.topicImageGalleryViewed, {
    pub_type: pubType,
    title,
    record_an: recordAn,
    is_free_preview: isFreePreview,
    referring_page: referringPage,
  });
};

export const logTopicVideoGalleryViewed = ({
  pubType,
  title,
  recordAn,
  isFreePreview,
  referringPage,
}) => {
  amplitude.log(EVENTS.topicVideoGalleryViewed, {
    pub_type: pubType,
    title,
    record_an: recordAn,
    is_free_preview: isFreePreview,
    referring_page: referringPage,
  });
};

export const logTopicAboutViewed = ({
  pubType,
  title,
  recordAn,
  isFreePreview,
  referringPage,
}) => {
  amplitude.log(EVENTS.topicAboutViewed, {
    pub_type: pubType,
    title,
    record_an: recordAn,
    is_free_preview: isFreePreview,
    referring_page: referringPage,
  });
};

export const logTopicChecklistViewed = ({
  pubType,
  title,
  recordAn,
  isFreePreview,
  referringPage,
}) => {
  amplitude.log(EVENTS.topicChecklistViewed, {
    pub_type: pubType,
    title,
    record_an: recordAn,
    is_free_preview: isFreePreview,
    referring_page: referringPage,
  });
};

export const logTopicAlgorithmsViewed = ({
  pubType,
  title,
  recordAn,
  isFreePreview,
  referringPage,
}) => {
  amplitude.log(EVENTS.topicAlgorithmsViewed, {
    pub_type: pubType,
    title,
    record_an: recordAn,
    is_free_preview: isFreePreview,
    referring_page: referringPage,
  });
};

export const logTopicUpdatesViewed = ({
  pubType,
  title,
  recordAn,
  isFreePreview,
  referringPage,
}) => {
  amplitude.log(EVENTS.topicUpdatesViewed, {
    pub_type: pubType,
    title,
    record_an: recordAn,
    is_free_preview: isFreePreview,
    referring_page: referringPage,
  });
};

export const logTopicSectionViewed = ({
  title,
  sectionTitle,
  pubType,
  recordAn,
  inDepth,
}) => {
  amplitude.log(EVENTS.topicSectionViewed, {
    title,
    section_title: sectionTitle,
    pub_type: pubType,
    record_an: recordAn,
    in_depth: inDepth,
  });
};

export const logTableViewed = ({
  title,
  isStandAlone,
  tableTitle,
  tableId,
  affordance,
  recordAn,
  navigateFrom,
}) => {
  amplitude.log(EVENTS.tableViewed, {
    title,
    is_standalone: isStandAlone,
    table_title: tableTitle,
    table_id: tableId,
    affordance,
    record_an: recordAn,
    navigate_from: navigateFrom,
  });
};

export const logTopicShareClicked = ({ title, recordAn }) => {
  amplitude.log(EVENTS.topicShareClicked, {
    title,
    record_an: recordAn,
  });
};

export const logTopicCiteClicked = ({ title, recordAn }) => {
  amplitude.log(EVENTS.topicCiteClicked, {
    title,
    record_an: recordAn,
  });
};

export const logTopicCiteCopyClicked = ({ title, recordAn }) => {
  amplitude.log(EVENTS.topicCiteCopyClicked, {
    title,
    record_an: recordAn,
  });
};

export const logTopicPrintClicked = ({ title, recordAn }) => {
  amplitude.log(EVENTS.topicPrintClicked, {
    title,
    record_an: recordAn,
  });
};

export const logTopicPrintConfirmClicked = ({ title, recordAn }) => {
  amplitude.log(EVENTS.topicPrintConfirmClicked, {
    title,
    record_an: recordAn,
  });
};

export const logTopicInThisSectionClicked = ({
  title,
  sectionTitle,
  recordAn,
  affordance,
}) => {
  amplitude.log(EVENTS.topicInThisSectionClicked, {
    title,
    section_title: sectionTitle,
    record_an: recordAn,
    affordance,
  });
};

export const logTopicPageNavigationClicked = ({
  title,
  direction,
  affordance,
}) => {
  amplitude.log(EVENTS.topicPageNavigationClicked, {
    title,
    direction,
    affordance,
  });
};

export const logTocClicked = ({
  title,
  sectionTitle,
  path,
  recordAn,
  docId,
}) => {
  amplitude.log(EVENTS.tocClicked, {
    title,
    section_title: sectionTitle,
    path,
    record_an: recordAn,
    drug_metadata: docId && { doc_id: docId },
  });
};

export const logImageViewed = ({ title, mediaId, type, affordance }) => {
  amplitude.log(EVENTS.imageViewed, {
    title,
    media_id: mediaId,
    type,
    affordance,
  });
};

export const logAlgorithmViewed = ({ title, mediaId, type, affordance }) => {
  amplitude.log(EVENTS.algorithmViewed, {
    title,
    media_id: mediaId,
    type,
    affordance,
  });
};

export const logVideoViewed = ({ title, mediaId, type, affordance }) => {
  amplitude.log(EVENTS.videoViewed, {
    title,
    media_id: mediaId,
    type,
    affordance,
  });
};

export const logVideoPlayed = ({ title, mediaId, type, affordance }) => {
  amplitude.log(EVENTS.videoPlayed, {
    title,
    media_id: mediaId,
    type,
    affordance,
  });
};

export const logFindOnPageClicked = ({
  title,
  recordAn,
  affordance,
  searchTerm,
}) => {
  amplitude.log(EVENTS.findOnPageClicked, {
    title,
    affordance,
    record_an: recordAn,
    search_term: searchTerm,
  });
};

export const logFindOnPageInitiated = ({ title, recordAn, searchTerm }) => {
  amplitude.log(EVENTS.findOnPageInitiated, {
    title,
    record_an: recordAn,
    search_term: searchTerm,
  });
};

export const logJumpLinkClicked = ({ title }) => {
  amplitude.log(EVENTS.jumpLinkClicked, {
    title,
  });
};

export const logTopicInDepthAnswersClicked = ({
  pubType,
  title,
  recordAn,
  referringPage,
  isFreePreview,
  docId,
}) => {
  amplitude.log(EVENTS.topicInDepthAnswersClicked, {
    pub_type: pubType,
    title,
    record_an: recordAn,
    referring_page: referringPage,
    is_free_preview: isFreePreview,
    drug_metadata: docId && { doc_id: docId },
  });
};

export const logTopicInDepthAnswersViewed = ({
  pubType,
  title,
  recordAn,
  referringPage,
  isFreePreview,
  docId,
}) => {
  amplitude.log(EVENTS.topicInDepthAnswersViewed, {
    pub_type: pubType,
    title,
    record_an: recordAn,
    referring_page: referringPage,
    is_free_preview: isFreePreview,
    drug_metadata: docId && { doc_id: docId },
  });
};

export const logTopicTablesGalleryViewed = ({
  pubType,
  title,
  recordAn,
  isFreePreview,
  referringPage,
}) =>
  amplitude.log(EVENTS.topicTablesGalleryViewed, {
    pub_type: pubType,
    title,
    record_an: recordAn,
    is_free_preview: isFreePreview,
    referring_page: referringPage,
  });

export const logTableViewInContextClicked = ({ title, tableId, affordance }) =>
  amplitude.log(EVENTS.tableViewInContextClicked, {
    title,
    table_id: tableId,
    affordance,
  });

export const logMerativeLinkClicked = ({
  title,
  navigateTo,
  navigateFrom,
  affordance,
}) => {
  amplitude.log(EVENTS.merativeLinkClicked, {
    title,
    navigate_to: navigateTo,
    navigate_from: navigateFrom,
    affordance,
  });
};

export const logCheckInteractionsClicked = ({
  pubType,
  title,
  sectionTitle,
  recordAn,
  affordance,
}) => {
  amplitude.log(EVENTS.checkInteractionsClicked, {
    pub_type: pubType,
    title,
    record_an: recordAn,
    section_title: sectionTitle,
    affordance,
  });
};

export const logBoxedWarningsClicked = ({
  pubType,
  title,
  recordAn,
  affordance,
}) => {
  amplitude.log(EVENTS.boxedWarningClicked, {
    pub_type: pubType,
    title,
    record_an: recordAn,
    affordance,
  });
};

export const logDrugConsultsClicked = ({
  title,
  recordAn,
  drugConsultTitle,
  docId,
  navigateFrom,
  affordance,
}) => {
  amplitude.log(EVENTS.drugConsultsClicked, {
    affordance,
    title,
    record_an: recordAn,
    drug_consult_title: drugConsultTitle,
    doc_id: docId,
    navigate_to: "Drug Consult",
    navigate_from: navigateFrom,
  });
};

export const logDecisionsPlacardClicked = (telemetryData) => {
  const { affordance, an, title, pubType, recordAn, pageTitle } = telemetryData;
  const eventProperties = {
    affordance,
    tool_an: an,
    tool_title: title,
    pub_type: pubType,
    record_an: recordAn,
    title: pageTitle,
  };
  amplitude.log(EVENTS.decisionsPlacardClicked, eventProperties);
};

export const logTopicFullTextLinkClicked = ({
  pubType,
  title,
  recordAn,
  affordance,
  tableTitleRef,
}) => {
  const amplitudeEventObject = {
    pub_type: pubType,
    title,
    record_an: recordAn,
    affordance,
  };
  if (tableTitleRef) {
    amplitudeEventObject["table_title"] = tableTitleRef.current;
  }
  amplitude.log(EVENTS.topicFullTextLinkClicked, amplitudeEventObject);
  if (tableTitleRef) {
    tableTitleRef.current = "";
  }
};

export const logTopicContentLinkClicked = ({
  pubType,
  title,
  recordAn,
  sectionTitle,
  linkText,
  linkUrl,
  isExternal,
  type,
}) => {
  const amplitudeEventObject = {
    pub_type: pubType,
    title,
    record_an: recordAn,
    section_title: sectionTitle,
    link_text: linkText,
    link_url: linkUrl,
    is_external: isExternal || false,
    type,
  };
  amplitude.log(EVENTS.topicContentLinkClicked, amplitudeEventObject);
};

export const logPdfViewed = ({ title, language, recordAn }) => {
  amplitude.log(EVENTS.pdfViewed, {
    title,
    language,
    record_an: recordAn,
  });
};

export const logTopicHeaderLinkClicked = ({ title, pubType }) => {
  amplitude.log(EVENTS.topicHeaderLinkClicked, {
    title,
    pub_type: pubType,
  });
};

const parseRightRailTelemetryData = (telemetryData) => ({
  pub_type: telemetryData.pubType,
  record_an: telemetryData.recordAn,
  affordance: telemetryData.affordance,
});

export const logRelatedTopicsLinkClicked = ({ title, ...telemetryData }) => {
  const event = { ...parseRightRailTelemetryData(telemetryData), title };
  amplitude.log(EVENTS.relatedTopicsClicked, event);
};

export const logRelatedContentLinkClicked = ({ title, ...telemetryData }) => {
  const event = { ...parseRightRailTelemetryData(telemetryData), title };
  amplitude.log(EVENTS.relatedContentClicked, event);
};
